import { format } from "date-fns";

export const showDateAndTime = (date) => {
    if (!date) return [];
    let time = [format(date, 'dd MMM yyyy'), format(date, 'dd MMM yyyy, hh:mm a')]
    return time;
}
